import * as React from "react";
import { useTranslation } from "react-i18next";
import Select from "components/common/Select";
import useWatchlistsV2 from "watchlist/hooks/useWatchlistsV2";
const WatchlistSelector = ({ id, value, onChange, filterType = void 0 }) => {
  const { t } = useTranslation("enterprise_common");
  const { watchlists, isLoading } = useWatchlistsV2();
  const options = watchlists.filter((w) => !filterType || w.type === filterType).map((w) => ({ value: w.id, label: w.name }));
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      inputId: id,
      placeholder: t("parameters.select_watchlist_placeholder"),
      onChange,
      value,
      options,
      isLoading
    }
  );
};
export default WatchlistSelector;
